<template>
  <div
    class="wrap-loading-card container-lg bg-white text-center d-flex justify-content-center align-items-center p-0"
    :class="{border: hasBorder}"
  >
    <p class="loading-spinner m-0">
      <span class="icon-Loading"></span>
    </p>
    <span class="ml-4">{{ $t('載入中') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    hasBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-loading-card {
  height: 218px;
  @media screen and (min-width: 768px) {
    border-radius: 24px;
  }
  &.border {
    border: 1px solid #ebebeb;
  }

  .icon-Loading {
    font-size: 48px;
  }
}
</style>
